import parser from 'ua-parser-js';

const getAllCustomerSegments = (customerSegments) => {
    let AllCustomerSegmentNames = [];
    const allCustomerSegments = Object.keys(customerSegments);
    allCustomerSegments.forEach((element) => {
        AllCustomerSegmentNames.push(...customerSegments[element]);
    });
    return AllCustomerSegmentNames;
};

const parsedUA = typeof window !== "undefined" ? parser(window?.navigator?.userAgent) : undefined;

export default (userSummary = {}, pageGroup = '', nativeapp = 'false', additionalAttrs = {}) => {
    const allCustomerSegments= userSummary && userSummary?.customerSegments && getAllCustomerSegments(userSummary?.customerSegments) || []
    const customerSegments = allCustomerSegments.map((item) => item?.customerSegmentName);
    const customerSegmentsToString = customerSegments.join(',')
    return ({
        market: document?.body?.getAttribute('data-country') || null,
        region: document?.body?.getAttribute('data-catalog') || null,
        language: document?.body?.getAttribute('data-language') || null,
        logged_in: userSummary.userAuthenticationStatus === "Full",
        is_eip: userSummary.isEip === true,
        new_returning: userSummary.hasOrder === 'true' ? 'returning user' : 'new user',
        view_name: pageGroup || null,
        browser: parsedUA?.browser?.name || null,
        device_type: parsedUA?.device?.type || 'desktop',
        platform_info: `${parsedUA?.os?.name || ''}${parsedUA?.os?.version || ''}` || null,
        native_app: nativeapp || 'false',
        user_agent: parsedUA?.ua || null,
        customer_segments: customerSegmentsToString || null,
        ...additionalAttrs
    })
} 